import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "analytique-avancee" };
const _hoisted_2 = { class: "card border-0 shadow-sm mb-25 p-20" };
const _hoisted_3 = { class: "row g-3 align-items-end" };
const _hoisted_4 = { class: "col-md-3" };
const _hoisted_5 = { class: "col-md-3" };
const _hoisted_6 = { class: "col-md-1" };
const _hoisted_7 = { class: "col-md-1" };
const _hoisted_8 = { class: "col-md-2" };
const _hoisted_9 = { class: "col-md-2" };
const _hoisted_10 = { class: "col-md-2" };
const _hoisted_11 = ["value"];
const _hoisted_12 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_13 = { key: 1 };
const _hoisted_14 = { class: "row mb-30 g-3" };
const _hoisted_15 = { class: "col-6 col-md-3" };
const _hoisted_16 = { class: "kpi-card bg-gradient-green text-white" };
const _hoisted_17 = { class: "kpi-value" };
const _hoisted_18 = { class: "col-6 col-md-3" };
const _hoisted_19 = { class: "kpi-card bg-gradient-blue text-white" };
const _hoisted_20 = { class: "kpi-value" };
const _hoisted_21 = { class: "col-6 col-md-3" };
const _hoisted_22 = { class: "kpi-card bg-gradient-purple text-white" };
const _hoisted_23 = { class: "kpi-value" };
const _hoisted_24 = { class: "col-6 col-md-3" };
const _hoisted_25 = { class: "kpi-card bg-gradient-orange text-white" };
const _hoisted_26 = { class: "kpi-value" };
const _hoisted_27 = { class: "col-md-6" };
const _hoisted_28 = { class: "card h-100 border-0 shadow-sm p-20" };
const _hoisted_29 = { class: "d-flex align-items-center gap-2" };
const _hoisted_30 = { class: "small fw-medium" };
const _hoisted_31 = { class: "fw-bold small" };
const _hoisted_32 = { class: "col-md-6" };
const _hoisted_33 = { class: "card h-100 border-0 shadow-sm p-20" };
const _hoisted_34 = {
    key: 1,
    class: "d-flex align-items-center justify-content-center text-muted small",
    style: { "height": "160px" }
};
const _hoisted_35 = { class: "row mb-30 g-3" };
const _hoisted_36 = { class: "col-6 col-md-3" };
const _hoisted_37 = { class: "kpi-card kpi-dark" };
const _hoisted_38 = { class: "kpi-value" };
const _hoisted_39 = { class: "col-6 col-md-3" };
const _hoisted_40 = { class: "kpi-card kpi-light" };
const _hoisted_41 = { class: "kpi-value" };
const _hoisted_42 = { class: "col-6 col-md-3" };
const _hoisted_43 = { class: "kpi-card kpi-teal" };
const _hoisted_44 = { class: "kpi-value" };
const _hoisted_45 = { class: "col-6 col-md-3" };
const _hoisted_46 = { class: "kpi-card kpi-warm" };
const _hoisted_47 = { class: "kpi-value" };
const _hoisted_48 = { class: "col-md-12" };
const _hoisted_49 = { class: "card border-0 shadow-sm p-20" };
const _hoisted_50 = {
    key: 1,
    class: "d-flex align-items-center justify-content-center text-muted small",
    style: { "height": "200px" }
};
const _hoisted_51 = { class: "row mb-30 g-3" };
const _hoisted_52 = { class: "col-md-5" };
const _hoisted_53 = { class: "card h-100 border-0 shadow-sm p-20" };
const _hoisted_54 = {
    key: 1,
    class: "d-flex align-items-center justify-content-center text-muted small",
    style: { "height": "260px" }
};
const _hoisted_55 = { class: "col-md-7" };
const _hoisted_56 = { class: "card h-100 border-0 shadow-sm p-20" };
const _hoisted_57 = { class: "table-responsive" };
const _hoisted_58 = { class: "table table-borderless align-middle table-sm" };
const _hoisted_59 = { class: "platform-badge" };
const _hoisted_60 = { class: "text-end fw-bold small" };
const _hoisted_61 = { class: "text-end small" };
const _hoisted_62 = { class: "text-end" };
const _hoisted_63 = { class: "badge-share" };
const _hoisted_64 = { class: "row mb-30 g-3" };
const _hoisted_65 = { class: "col-md-7" };
const _hoisted_66 = { class: "card border-0 shadow-sm p-20" };
const _hoisted_67 = { class: "table-responsive" };
const _hoisted_68 = { class: "table table-borderless align-middle table-sm" };
const _hoisted_69 = { class: "rank-badge" };
const _hoisted_70 = { class: "small fw-medium" };
const _hoisted_71 = { class: "text-end small" };
const _hoisted_72 = { class: "text-end small fw-bold" };
const _hoisted_73 = { style: { "min-width": "100px" } };
const _hoisted_74 = {
    class: "progress",
    style: { "height": "6px", "border-radius": "3px" }
};
const _hoisted_75 = { class: "col-md-5" };
const _hoisted_76 = { class: "card border-0 shadow-sm p-20" };
const _hoisted_77 = { class: "d-flex justify-content-between mb-1" };
const _hoisted_78 = { class: "small fw-medium" };
const _hoisted_79 = { class: "small fw-bold text-success" };
const _hoisted_80 = {
    class: "progress",
    style: { "height": "10px", "border-radius": "5px" }
};
const _hoisted_81 = { class: "section-header mb-3" };
const _hoisted_82 = { class: "text-muted small mb-0" };
const _hoisted_83 = {
    key: 0,
    class: "d-block mt-1 text-primary",
    style: { "font-size": "0.85em" }
};
const _hoisted_84 = { class: "row mb-30 g-3" };
const _hoisted_85 = { class: "col-6 col-md-3" };
const _hoisted_86 = { class: "kpi-card bg-gradient-red text-white" };
const _hoisted_87 = { class: "kpi-value" };
const _hoisted_88 = { class: "col-6 col-md-3" };
const _hoisted_89 = { class: "kpi-card kpi-light" };
const _hoisted_90 = { class: "kpi-value text-danger" };
const _hoisted_91 = { class: "col-6 col-md-3" };
const _hoisted_92 = { class: "kpi-card kpi-dark" };
const _hoisted_93 = { class: "kpi-value" };
const _hoisted_94 = { class: "col-6 col-md-3" };
const _hoisted_95 = { class: "kpi-card kpi-teal" };
const _hoisted_96 = { class: "kpi-value" };
const _hoisted_97 = {
    key: 0,
    class: "col-md-12"
};
const _hoisted_98 = { class: "card border-0 shadow-sm p-20" };
const _hoisted_99 = { class: "table-responsive" };
const _hoisted_100 = { class: "table table-borderless align-middle table-sm" };
const _hoisted_101 = { class: "bg-light px-2 py-1 rounded small" };
const _hoisted_102 = { class: "text-end small" };
const _hoisted_103 = { class: "text-end small" };
const _hoisted_104 = { class: "text-end small" };
const _hoisted_105 = { class: "text-end small" };
const _hoisted_106 = { class: "text-end small" };
const _hoisted_107 = {
    key: 0,
    class: "badge bg-light text-dark border"
};
const _hoisted_108 = { key: 1 };
const _hoisted_109 = { class: "text-end small fw-bold" };
const _hoisted_110 = { class: "text-end small text-danger" };
const _hoisted_111 = {
    key: 1,
    class: "col-md-12"
};
const _hoisted_112 = { class: "row mb-30" };
const _hoisted_113 = { class: "col-12" };
const _hoisted_114 = { class: "card border-0 shadow-sm p-20" };
const _hoisted_115 = { class: "d-flex align-items-center justify-content-between mb-15" };
const _hoisted_116 = { class: "fw-bold" };
const _hoisted_117 = { class: "fw-bold" };
const _hoisted_118 = {
    key: 1,
    class: "d-flex align-items-center justify-content-center text-muted small",
    style: { "height": "260px" }
};
const _hoisted_119 = { class: "row mb-30 g-3" };
const _hoisted_120 = { class: "col-md-5" };
const _hoisted_121 = { class: "card h-100 border-0 shadow-sm p-20" };
const _hoisted_122 = {
    key: 1,
    class: "d-flex align-items-center justify-content-center text-muted small",
    style: { "height": "220px" }
};
const _hoisted_123 = { class: "d-flex justify-content-around mt-3" };
const _hoisted_124 = { class: "text-center" };
const _hoisted_125 = { class: "fw-bold text-success" };
const _hoisted_126 = { class: "text-center" };
const _hoisted_127 = {
    class: "fw-bold",
    style: { "color": "#2B2A3F" }
};
const _hoisted_128 = { class: "col-md-7" };
const _hoisted_129 = { class: "card h-100 border-0 shadow-sm p-20" };
const _hoisted_130 = { class: "table-responsive" };
const _hoisted_131 = { class: "table table-borderless align-middle table-sm" };
const _hoisted_132 = { class: "rank-badge" };
const _hoisted_133 = { class: "d-flex align-items-center gap-2" };
const _hoisted_134 = { class: "client-avatar" };
const _hoisted_135 = { class: "small fw-medium" };
const _hoisted_136 = { class: "text-end small fw-bold" };
const _hoisted_137 = { class: "text-end small" };
const _hoisted_138 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_apexchart = _resolveComponent("apexchart");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "Début", -1)),
                    _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.localFilters.startDate) = $event)),
                        class: "form-control form-control-sm",
                        onChange: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchAll && _ctx.fetchAll(...args)))
                    }, null, 544), [
                        [_vModelText, _ctx.localFilters.startDate]
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "Fin", -1)),
                    _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.localFilters.endDate) = $event)),
                        class: "form-control form-control-sm",
                        onChange: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchAll && _ctx.fetchAll(...args)))
                    }, null, 544), [
                        [_vModelText, _ctx.localFilters.endDate]
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "H. Début", -1)),
                    _withDirectives(_createElementVNode("input", {
                        type: "time",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.localFilters.startTime) = $event)),
                        class: "form-control form-control-sm",
                        onChange: _cache[5] || (_cache[5] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchAll && _ctx.fetchAll(...args)))
                    }, null, 544), [
                        [_vModelText, _ctx.localFilters.startTime]
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "H. Fin", -1)),
                    _withDirectives(_createElementVNode("input", {
                        type: "time",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.localFilters.endTime) = $event)),
                        class: "form-control form-control-sm",
                        onChange: _cache[7] || (_cache[7] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchAll && _ctx.fetchAll(...args)))
                    }, null, 544), [
                        [_vModelText, _ctx.localFilters.endTime]
                    ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "Paiement", -1)),
                    _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.localFilters.paymentMethod) = $event)),
                        onChange: _cache[9] || (_cache[9] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchAll && _ctx.fetchAll(...args)))
                    }, [...(_cache[18] || (_cache[18] = [
                            _createStaticVNode("<option value=\"\" data-v-4d3d4fcc>Tous</option><option value=\"cash\" data-v-4d3d4fcc>Espèces</option><option value=\"card\" data-v-4d3d4fcc>Carte</option><option value=\"online\" data-v-4d3d4fcc>En ligne</option><option value=\"voucher\" data-v-4d3d4fcc>Bon</option>", 5)
                        ]))], 544), [
                        [_vModelSelect, _ctx.localFilters.paymentMethod]
                    ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "Type", -1)),
                    _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.localFilters.orderType) = $event)),
                        onChange: _cache[11] || (_cache[11] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchAll && _ctx.fetchAll(...args)))
                    }, [...(_cache[20] || (_cache[20] = [
                            _createElementVNode("option", { value: "" }, "Tous", -1),
                            _createElementVNode("option", { value: "dine_in" }, "Sur place", -1),
                            _createElementVNode("option", { value: "takeaway" }, "À emporter", -1),
                            _createElementVNode("option", { value: "delivery" }, "Livraison", -1)
                        ]))], 544), [
                        [_vModelSelect, _ctx.localFilters.orderType]
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "Zone Livraison", -1)),
                    _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.localFilters.deliveryZone) = $event)),
                        onChange: _cache[13] || (_cache[13] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchAll && _ctx.fetchAll(...args)))
                    }, [
                        _cache[22] || (_cache[22] = _createElementVNode("option", { value: "" }, "Toutes les zones", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryZones, (z) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: z,
                                value: z
                            }, _toDisplayString(z), 9, _hoisted_11));
                        }), 128))
                    ], 544), [
                        [_vModelSelect, _ctx.localFilters.deliveryZone]
                    ])
                ])
            ])
        ]),
        (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("div", {
                        class: "spinner-border text-primary",
                        role: "status"
                    }, null, -1),
                    _createElementVNode("p", { class: "text-muted mt-3" }, "Chargement des données analytiques…", -1)
                ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "section-header mb-3" }, [
                    _createElementVNode("span", { class: "section-badge" }, "1"),
                    _createElementVNode("h5", { class: "fw-bold mb-0" }, "Chiffre d'Affaires (CA)"),
                    _createElementVNode("p", { class: "text-muted small mb-0" }, "En fonction des dates, heures, moyens de paiement et types de commande")
                ], -1)),
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _cache[25] || (_cache[25] = _createElementVNode("p", { class: "kpi-label" }, "CA Total", -1)),
                            _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.formatCHF(_ctx.stats.totalCA)), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _cache[26] || (_cache[26] = _createElementVNode("p", { class: "kpi-label" }, "CA Emporter", -1)),
                            _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.formatCHF(_ctx.stats.caByType.takeaway)), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                            _cache[27] || (_cache[27] = _createElementVNode("p", { class: "kpi-label" }, "CA Livraison", -1)),
                            _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.formatCHF(_ctx.stats.caByType.delivery)), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                            _cache[28] || (_cache[28] = _createElementVNode("p", { class: "kpi-label" }, "CA Sur place", -1)),
                            _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.formatCHF(_ctx.stats.caByType.dine_in)), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                            _cache[29] || (_cache[29] = _createElementVNode("h6", { class: "fw-bold mb-15 text-muted text-uppercase small" }, "CA par Moyen de Paiement", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.caByPayment, (pm) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: pm.method,
                                    class: "d-flex justify-content-between align-items-center mb-2"
                                }, [
                                    _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["payment-dot", `dot-${pm.method}`])
                                        }, null, 2),
                                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.translatePayment(pm.method)), 1)
                                    ]),
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.formatCHF(pm.amount)), 1)
                                ]));
                            }), 128))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                            _cache[30] || (_cache[30] = _createElementVNode("h6", { class: "fw-bold mb-15 text-muted text-uppercase small" }, "Évolution Journalière du CA", -1)),
                            (_ctx.caSeries[0]?.data?.length > 0)
                                ? (_openBlock(), _createBlock(_component_apexchart, {
                                    type: "area",
                                    height: "160",
                                    options: _ctx.caChartOptions,
                                    series: _ctx.caSeries,
                                    key: 'ca-chart-' + JSON.stringify(_ctx.caSeries)
                                }, null, 8, ["options", "series"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_34, " Aucune donnée "))
                        ])
                    ])
                ]),
                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "section-header mb-3" }, [
                    _createElementVNode("span", { class: "section-badge" }, "2"),
                    _createElementVNode("h5", { class: "fw-bold mb-0" }, "Commandes & Panier Moyen"),
                    _createElementVNode("p", { class: "text-muted small mb-0" }, "Volume de commandes et valeur moyenne par période et filtre")
                ], -1)),
                _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                            _cache[31] || (_cache[31] = _createElementVNode("p", { class: "kpi-label" }, "Nb Commandes", -1)),
                            _createElementVNode("h2", _hoisted_38, _toDisplayString(_ctx.stats.totalOrders), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                            _cache[32] || (_cache[32] = _createElementVNode("p", { class: "kpi-label" }, "Panier Moyen", -1)),
                            _createElementVNode("h2", _hoisted_41, _toDisplayString(_ctx.formatCHF(_ctx.stats.avgBasket)), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                            _cache[33] || (_cache[33] = _createElementVNode("p", { class: "kpi-label" }, "Commandes Livraison", -1)),
                            _createElementVNode("h2", _hoisted_44, _toDisplayString(_ctx.stats.ordersByType.delivery), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                            _cache[34] || (_cache[34] = _createElementVNode("p", { class: "kpi-label" }, "Commandes Emporter", -1)),
                            _createElementVNode("h2", _hoisted_47, _toDisplayString(_ctx.stats.ordersByType.takeaway), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                            _cache[35] || (_cache[35] = _createElementVNode("h6", { class: "fw-bold mb-15 text-muted text-uppercase small" }, "Commandes par Tranche Horaire", -1)),
                            (_ctx.ordersBarSeries[0]?.data?.length > 0)
                                ? (_openBlock(), _createBlock(_component_apexchart, {
                                    id: "chart-orders-bar",
                                    type: "bar",
                                    height: "200",
                                    options: _ctx.ordersBarOptions,
                                    series: _ctx.ordersBarSeries,
                                    key: 'orders-' + _ctx.ordersBarSeries[0].data.length
                                }, null, 8, ["options", "series"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_50, " Aucune donnée horaire disponible "))
                        ])
                    ])
                ]),
                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "section-header mb-3" }, [
                    _createElementVNode("span", { class: "section-badge" }, "3"),
                    _createElementVNode("h5", { class: "fw-bold mb-0" }, "Répartition par Canal de Vente"),
                    _createElementVNode("p", { class: "text-muted small mb-0" }, "App / Site / Téléphone / Sur place / Plateformes externes")
                ], -1)),
                _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                            (_ctx.platformSeries.length > 0 && _ctx.platformSeries.some(v => v > 0))
                                ? (_openBlock(), _createBlock(_component_apexchart, {
                                    id: "chart-platforms",
                                    type: "donut",
                                    height: "260",
                                    options: _ctx.platformChartOptions,
                                    series: _ctx.platformSeries,
                                    key: 'platforms-' + _ctx.platformSeries.join('-')
                                }, null, 8, ["options", "series"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_54, " Aucun canal de vente "))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                            _cache[37] || (_cache[37] = _createElementVNode("h6", { class: "fw-bold mb-15 text-muted text-uppercase small" }, "Détail par Plateforme", -1)),
                            _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("table", _hoisted_58, [
                                    _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", { class: "text-muted" }, [
                                            _createElementVNode("th", { class: "small" }, "Canal"),
                                            _createElementVNode("th", { class: "text-end small" }, "Commandes"),
                                            _createElementVNode("th", { class: "text-end small" }, "CA"),
                                            _createElementVNode("th", { class: "text-end small" }, "Part")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.platforms, (p) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: p.platform
                                            }, [
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("span", _hoisted_59, _toDisplayString(p.platform), 1)
                                                ]),
                                                _createElementVNode("td", _hoisted_60, _toDisplayString(p.count), 1),
                                                _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.formatCHF(p.revenue)), 1),
                                                _createElementVNode("td", _hoisted_62, [
                                                    _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.stats.totalOrders > 0 ? ((p.count / _ctx.stats.totalOrders) * 100).toFixed(1) : 0) + "%", 1)
                                                ])
                                            ]));
                                        }), 128))
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]),
                _cache[63] || (_cache[63] = _createElementVNode("div", { class: "section-header mb-3" }, [
                    _createElementVNode("span", { class: "section-badge" }, "4"),
                    _createElementVNode("h5", { class: "fw-bold mb-0" }, "CA par Produit & Attach Rate"),
                    _createElementVNode("p", { class: "text-muted small mb-0" }, "% de commandes avec boisson / dessert / entrée, etc.")
                ], -1)),
                _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                            _cache[39] || (_cache[39] = _createElementVNode("h6", { class: "fw-bold mb-15 text-muted text-uppercase small" }, "Top Produits par CA", -1)),
                            _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("table", _hoisted_68, [
                                    _cache[38] || (_cache[38] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", { class: "text-muted" }, [
                                            _createElementVNode("th", { class: "small" }, "#"),
                                            _createElementVNode("th", { class: "small" }, "Produit"),
                                            _createElementVNode("th", { class: "text-end small" }, "Qté"),
                                            _createElementVNode("th", { class: "text-end small" }, "CA"),
                                            _createElementVNode("th", { class: "small" }, "Part CA")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.topProducts, (p, i) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: p.name
                                            }, [
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("span", _hoisted_69, _toDisplayString(i + 1), 1)
                                                ]),
                                                _createElementVNode("td", _hoisted_70, _toDisplayString(p.name), 1),
                                                _createElementVNode("td", _hoisted_71, _toDisplayString(p.count), 1),
                                                _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.formatCHF(p.revenue)), 1),
                                                _createElementVNode("td", _hoisted_73, [
                                                    _createElementVNode("div", _hoisted_74, [
                                                        _createElementVNode("div", {
                                                            class: "progress-bar bg-success",
                                                            style: _normalizeStyle({ width: _ctx.stats.totalCA > 0 ? ((p.revenue / _ctx.stats.totalCA) * 100).toFixed(0) + '%' : '0%' })
                                                        }, null, 4)
                                                    ])
                                                ])
                                            ]));
                                        }), 128))
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                            _cache[40] || (_cache[40] = _createElementVNode("h6", { class: "fw-bold mb-15 text-muted text-uppercase small" }, "Attach Rate par Catégorie", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachRates, (ar) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: ar.label,
                                    class: "mb-20"
                                }, [
                                    _createElementVNode("div", _hoisted_77, [
                                        _createElementVNode("span", _hoisted_78, _toDisplayString(ar.label), 1),
                                        _createElementVNode("span", _hoisted_79, _toDisplayString(ar.rate.toFixed(1)) + "%", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_80, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["progress-bar", ar.color]),
                                            style: _normalizeStyle({ width: ar.rate + '%' })
                                        }, null, 6)
                                    ])
                                ]));
                            }), 128))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_81, [
                    _cache[43] || (_cache[43] = _createElementVNode("span", { class: "section-badge" }, "5", -1)),
                    _cache[44] || (_cache[44] = _createElementVNode("h5", { class: "fw-bold mb-0" }, "Codes Promotionnels", -1)),
                    _createElementVNode("p", _hoisted_82, [
                        _cache[42] || (_cache[42] = _createTextVNode(" CA avec code promo et coût des remises ", -1)),
                        (_ctx.activeFiltersText)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_83, [
                                _cache[41] || (_cache[41] = _createElementVNode("i", { class: "ph-bold ph-funnel me-1" }, null, -1)),
                                _createTextVNode(" Filtres : " + _toDisplayString(_ctx.activeFiltersText), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, [
                            _cache[45] || (_cache[45] = _createElementVNode("p", { class: "kpi-label" }, "CA avec Promo", -1)),
                            _createElementVNode("h3", _hoisted_87, _toDisplayString(_ctx.formatCHF(_ctx.stats.promoStats.caWithPromo)), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                            _cache[46] || (_cache[46] = _createElementVNode("p", { class: "kpi-label" }, "Coût Remises", -1)),
                            _createElementVNode("h3", _hoisted_90, "-" + _toDisplayString(_ctx.formatCHF(_ctx.stats.promoStats.discountCost)), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("div", _hoisted_92, [
                            _cache[47] || (_cache[47] = _createElementVNode("p", { class: "kpi-label" }, "Commandes Promues", -1)),
                            _createElementVNode("h3", _hoisted_93, _toDisplayString(_ctx.stats.promoStats.promoOrders), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("div", _hoisted_95, [
                            _cache[48] || (_cache[48] = _createElementVNode("p", { class: "kpi-label" }, "Taux d'Utilisation", -1)),
                            _createElementVNode("h3", _hoisted_96, _toDisplayString(_ctx.stats.totalOrders > 0 ? ((_ctx.stats.promoStats.promoOrders / _ctx.stats.totalOrders) * 100).toFixed(1) : 0) + "%", 1)
                        ])
                    ]),
                    (_ctx.stats.promoStats.codes.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                            _createElementVNode("div", _hoisted_98, [
                                _cache[50] || (_cache[50] = _createElementVNode("h6", { class: "fw-bold mb-15 text-muted text-uppercase small" }, "Détail par Code Promo", -1)),
                                _createElementVNode("div", _hoisted_99, [
                                    _createElementVNode("table", _hoisted_100, [
                                        _cache[49] || (_cache[49] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", { class: "text-muted" }, [
                                                _createElementVNode("th", { class: "small" }, "Code"),
                                                _createElementVNode("th", { class: "text-end small" }, "Utilisations"),
                                                _createElementVNode("th", { class: "small text-end" }, "Date et heure"),
                                                _createElementVNode("th", { class: "small text-end" }, "Paiement"),
                                                _createElementVNode("th", { class: "small text-end" }, "Zone"),
                                                _createElementVNode("th", { class: "small text-end" }, "Type"),
                                                _createElementVNode("th", { class: "text-end small" }, "CA Généré"),
                                                _createElementVNode("th", { class: "text-end small" }, "Remise Totale")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.promoStats.codes, (c) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: c.orderId || c.code
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("code", _hoisted_101, _toDisplayString(c.code), 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_102, _toDisplayString(c.usageCount), 1),
                                                    _createElementVNode("td", _hoisted_103, _toDisplayString(_ctx.formatDate(c.date, "dd/MM/yyyy HH:mm")), 1),
                                                    _createElementVNode("td", _hoisted_104, _toDisplayString(c.paymentMethod ? _ctx.translatePayment(c.paymentMethod) : '-'), 1),
                                                    _createElementVNode("td", _hoisted_105, _toDisplayString(c.zone || '-'), 1),
                                                    _createElementVNode("td", _hoisted_106, [
                                                        (c.orderType)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_107, _toDisplayString(c.orderType === 'dine_in' ? 'Sur place' : c.orderType === 'takeaway' ? 'À emporter' : 'Livraison'), 1))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_108, "-"))
                                                    ]),
                                                    _createElementVNode("td", _hoisted_109, _toDisplayString(_ctx.formatCHF(c.ca)), 1),
                                                    _createElementVNode("td", _hoisted_110, "-" + _toDisplayString(_ctx.formatCHF(c.discount)), 1)
                                                ]));
                                            }), 128))
                                        ])
                                    ])
                                ])
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_111, [...(_cache[51] || (_cache[51] = [
                                _createElementVNode("div", { class: "card border-0 shadow-sm p-20 text-center text-muted" }, [
                                    _createElementVNode("i", { class: "ph-bold ph-ticket fs-40 mb-2" }),
                                    _createElementVNode("p", { class: "small mb-0" }, "Aucun code promo utilisé sur cette période")
                                ], -1)
                            ]))]))
                ]),
                _cache[64] || (_cache[64] = _createElementVNode("div", { class: "section-header mb-3" }, [
                    _createElementVNode("span", { class: "section-badge" }, "6"),
                    _createElementVNode("h5", { class: "fw-bold mb-0" }, "Graphique Heures de Pointe"),
                    _createElementVNode("p", { class: "text-muted small mb-0" }, "Nombre de commandes par heure de la journée")
                ], -1)),
                _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("div", _hoisted_113, [
                        _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("div", _hoisted_115, [
                                _createElementVNode("div", null, [
                                    _cache[52] || (_cache[52] = _createElementVNode("span", { class: "text-muted small" }, "Heure de pointe : ", -1)),
                                    _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.peakHourLabel), 1)
                                ]),
                                _createElementVNode("div", null, [
                                    _cache[53] || (_cache[53] = _createElementVNode("span", { class: "text-muted small" }, "Max commandes : ", -1)),
                                    _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.peakHourMax), 1)
                                ])
                            ]),
                            (_ctx.peakHourSeries[0]?.data?.length > 0)
                                ? (_openBlock(), _createBlock(_component_apexchart, {
                                    id: "chart-peak-hours",
                                    type: "bar",
                                    height: "260",
                                    options: _ctx.peakHourChartOptions,
                                    series: _ctx.peakHourSeries,
                                    key: 'peak-' + _ctx.peakHourSeries[0].data.length
                                }, null, 8, ["options", "series"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_118, " Aucune donnée d'heure de pointe "))
                        ])
                    ])
                ]),
                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "section-header mb-3" }, [
                    _createElementVNode("span", { class: "section-badge" }, "7"),
                    _createElementVNode("h5", { class: "fw-bold mb-0" }, "Analyse Clients"),
                    _createElementVNode("p", { class: "text-muted small mb-0" }, "Nouveaux vs récurrents, top clients par période et type")
                ], -1)),
                _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("div", _hoisted_120, [
                        _createElementVNode("div", _hoisted_121, [
                            _cache[56] || (_cache[56] = _createElementVNode("h6", { class: "fw-bold mb-15 text-muted text-uppercase small" }, "Nouveaux VS Récurrents", -1)),
                            (_ctx.clientSegSeries[0] > 0 || _ctx.clientSegSeries[1] > 0)
                                ? (_openBlock(), _createBlock(_component_apexchart, {
                                    id: "chart-clients-seg",
                                    type: "donut",
                                    height: "220",
                                    options: _ctx.clientSegChartOptions,
                                    series: _ctx.clientSegSeries,
                                    key: 'clients-' + JSON.stringify(_ctx.clientSegSeries)
                                }, null, 8, ["options", "series"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_122, " Aucun client sur cette période ")),
                            _createElementVNode("div", _hoisted_123, [
                                _createElementVNode("div", _hoisted_124, [
                                    _cache[54] || (_cache[54] = _createElementVNode("p", { class: "small text-muted mb-0" }, "Nouveaux", -1)),
                                    _createElementVNode("h4", _hoisted_125, _toDisplayString(_ctx.stats.clients.newClients), 1)
                                ]),
                                _createElementVNode("div", _hoisted_126, [
                                    _cache[55] || (_cache[55] = _createElementVNode("p", { class: "small text-muted mb-0" }, "Récurrents", -1)),
                                    _createElementVNode("h4", _hoisted_127, _toDisplayString(_ctx.stats.clients.returning), 1)
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_128, [
                        _createElementVNode("div", _hoisted_129, [
                            _cache[59] || (_cache[59] = _createElementVNode("h6", { class: "fw-bold mb-15 text-muted text-uppercase small" }, "Top 10 Clients", -1)),
                            _createElementVNode("div", _hoisted_130, [
                                _createElementVNode("table", _hoisted_131, [
                                    _cache[58] || (_cache[58] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", { class: "text-muted" }, [
                                            _createElementVNode("th", { class: "small" }, "#"),
                                            _createElementVNode("th", { class: "small" }, "Client"),
                                            _createElementVNode("th", { class: "text-end small" }, "Commandes"),
                                            _createElementVNode("th", { class: "text-end small" }, "CA Total"),
                                            _createElementVNode("th", { class: "small" }, "Type")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.clients.topClients, (c, i) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: c.id
                                            }, [
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("span", _hoisted_132, _toDisplayString(i + 1), 1)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_133, [
                                                        _createElementVNode("div", _hoisted_134, _toDisplayString((c.name || 'A').charAt(0).toUpperCase()), 1),
                                                        _createElementVNode("span", _hoisted_135, _toDisplayString(c.name || 'Invité'), 1)
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_136, _toDisplayString(c.orderCount), 1),
                                                _createElementVNode("td", _hoisted_137, _toDisplayString(_ctx.formatCHF(c.totalAmount)), 1),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["badge", c.isNew ? 'badge-new' : 'badge-returning'])
                                                    }, _toDisplayString(c.isNew ? 'Nouveau' : 'Récurrent'), 3)
                                                ])
                                            ]));
                                        }), 128)),
                                        (_ctx.stats.clients.topClients.length === 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_138, [...(_cache[57] || (_cache[57] = [
                                                    _createElementVNode("td", {
                                                        colspan: "5",
                                                        class: "text-center text-muted small py-4"
                                                    }, "Aucun client trouvé", -1)
                                                ]))]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]))
    ]));
}
